export const toSafeNullableString = (value) => {
  const normalized = String(value || '').trim();
  return normalized || null;
};
